import { Box, Theme, Typography, useMediaQuery } from "@material-ui/core";
import jsonExport from "jsonexport/dist";
import moment from "moment";
import * as React from "react";
import { BooleanField, Datagrid, downloadCSV, Filter, List, ReferenceInput, SelectInput, TextField, TextInput, useListContext } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";

const UnitReportFilter = (props) => {
  return (
    <Filter {...props}>
      {/* <TextInput
        label="Video Title"
        // source="videoTitle.contains($) || videoId == null"
        source="videoTitle.contains($)"
        alwaysOn
      /> */}
      <ReferenceInput label="Video Title" source="videoId__eq" reference="videos" alwaysOn required>
        <SelectInput optionText="title" />
      </ReferenceInput>
      <TextInput label="Directorate" source="department__contains" alwaysOn />
      <TextInput label="Management" source="division__contains" alwaysOn />
      <TextInput label="Section" source="section__contains" />
    </Filter>
  );
};

const Empty = () => {
  const { filterValues } = useListContext();

  return !filterValues.videoId__eq ? (
    <Box textAlign="center" m={1}>
      <Typography variant="body1">
        <br />
        Please select the video title
      </Typography>
    </Box>
  ) : null;
};

const exporter = (reports: any[]) => {
  const reportsForExport = reports.map((report) => {
    return {
      "Video Id": report.videoId,
      "Video Title": report.title,
      Employee: report.employee,
      "Employee Name": report.employeeName,
      Position: report.position,
      Directorate: report.department,
      Management: report.division,
      Section: report.section,
      "Has Watched": report.hasWatched,
    };
  });

  jsonExport(reportsForExport, { rowDelimiter: ";" }, (err: any, csv: any) => {
    if (err) return console.log(err);

    //UTF8
    const bom = "\uFEFF";
    downloadCSV(`${bom} ${csv}`, `UnitReport-${moment().format("yyyMMDDHHmmss")}`);
  });
};

const UnitReportList = (props) => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.between("xs", "md"));

  return (
    <AuthorizedCheck>
      <List
        {...props}
        bulkActionButtons={false}
        filters={<UnitReportFilter />}
        title="Unit Report"
        sort={{ field: "hasWatched", order: "DESC" }}
        exporter={exporter}
        empty={false}
      >
        {isSmall ? (
          <Datagrid>
            <TextField source="title" label="Video Title" />
            <TextField source="employeeName" label="Employee Name" />
            <BooleanField source="hasWatched" label="Has Watched" />
          </Datagrid>
        ) : (
          <Datagrid empty={<Empty />}>
            <TextField source="title" label="Video Title" />
            <TextField source="employee" />
            <TextField source="employeeName" label="Employee Name" />
            {/* <DateField source="lastWatchDate" label="Last Watch Date" /> */}
            <TextField source="position" />
            <TextField source="department" label="Directorate" />
            <TextField source="division" label="Management" />
            <TextField source="section" />
            <BooleanField source="hasWatched" label="Has Watched" />
          </Datagrid>
        )}
      </List>
    </AuthorizedCheck>
  );
};
export default UnitReportList;
